import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import Clickwrap from 'components/Clickwrap';
import Select from 'components/FormFields/Select';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';

import './view-options.scss';

export const ViewOptionsHeading = ({ className, children, ...restProps }) => {
  return (
    <h6
      className={clsx('view-options__title', className)}
      {...restProps}
    >
      {children}
    </h6>
  );
};

export const ViewOptionsCheckbox = ({
  id,
  className,
  onChangeCheck,
  children,
  inputProps,
  labelProps,
  ...restProps
}) => {
  const clickwrapColor = '#676767';
  const { className: inputClass, ...restInputProps } = inputProps || {};
  const { className: labelClass, ...restLabelProps } = labelProps || {};
  return (
    <div
      className={clsx('view-option', 'view-option--checkbox', className)}
      {...restProps}
    >
      <Clickwrap
        name={id}
        color={clickwrapColor}
        className={clsx('view-option__checkbox', 'small', inputClass)}
        {...restInputProps}
      />
      <label
        htmlFor={id}
        className={clsx('view-option__label', labelClass)}
        {...restLabelProps}
      >
        {children}
      </label>
    </div>
  );
};

export const ViewOptionsOption = ({
  id,
  className,
  labelClass,
  children,
  inputProps,
  ...restProps
}) => {
  const { className: inputClass, ...restInputProps } = inputProps;
  return (
    <div
      className={clsx('view-option', 'view-option--option', className)}
      {...restProps}
    >
      <input
        type="radio"
        id={id}
        className={clsx('view-option__option', inputClass)}
        {...restInputProps}
      />
      <label
        htmlFor={id}
        className={clsx('view-option__label', labelClass)}
      >
        {children}
      </label>
    </div>
  );
};

export const ViewOptionsSelect = ({
  inputProps,
  children,
}) => {
  return (
    <div className="view-option view-option--select">
      <Select
        className="view-option__select"
        {...inputProps}
      >
        {children}
      </Select>
    </div>
  );
};

const ViewOptions = ({
  afterDismiss,
  scrollLockOnOpen = false,
  adjustOnVerticalOverflow = true,
  className,
  menuClass,
  children,
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const show = () => {
    setShowOptions(true);
  };

  const dismiss = () => {
    setShowOptions(false);
    afterDismiss?.call();
  };

  const trigger = (
    <DropdownButton
      className="button--unstyled button--text-stretch view-options__trigger"
      showIcon
    >
      View Options
    </DropdownButton>
  );

  return (
    <APResponsiveDropdown
      opened={showOptions}
      show={show}
      dismiss={dismiss}
      triggerButton={trigger}
      className={clsx('view-options', className)}
      menuClass={clsx('view-options__menu', menuClass)}
      drawerPosition="right"
      scrollLockOnOpen={scrollLockOnOpen}
      adjustOnVerticalOverflow={adjustOnVerticalOverflow}
    >
      <div className="view-options__content">
        {children}
      </div>
    </APResponsiveDropdown>
  );
};

ViewOptions.propTypes = {
  afterDismiss: PropTypes.func,
  scrollLockOnOpen: PropTypes.bool,
  adjustOnVerticalOverflow: PropTypes.bool,
  className: PropTypes.string,
};

ViewOptions.defaultProps = {
  scrollLockOnOpen: false,
  adjustOnVerticalOverflow: true,
};

export default ViewOptions;
